import React from 'react'
import { getObjValueByKey } from '../../../../../utils'
import { makeStyles } from '@material-ui/core'
import { tableControlsKeyToHideOnHover, tableControlsKeyToShowOnHover } from '../table/table-controls'
import {
    tableVirtualizedStyles,
    getOddRowBackground,
    getEvenRowBackground,
    HIERARCHY_DROPDOWN_OUTER_WIDTH,
    HIERARCHY_DROPDOWN_BTN_WIDTH
} from './styles'
import cl from 'classnames'

const useStyles = makeStyles(theme => ({
    ...tableVirtualizedStyles(theme),
    root: {
        display: 'flex',
        color: theme.textPrimary
    },
    cellInnerEven: {
        background: getEvenRowBackground(theme)
    },
    cellInnerOdd: {
        background: getOddRowBackground(theme)
    },
    clickableInnerRowRoot: {
        '&:hover $cellInner': {
            cursor: 'pointer'
        }
    },
    highlightFirstColumnOnHover: {
        '&:hover $firstCellInner': {
            color: `${theme.primary} !important`
        }
    },
    firstCellInner: {},
    cellRoot: {
        height: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    cellWithEllipsis: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    dropdownRoot: {
        width: HIERARCHY_DROPDOWN_OUTER_WIDTH,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    dropdownBtn: {
        margin: 0,
        padding: 0,
        width: HIERARCHY_DROPDOWN_BTN_WIDTH,
        height: HIERARCHY_DROPDOWN_BTN_WIDTH,
        color: theme.textPrimary
    },
    noShink: {
        flexShrink: 0
    },
    cellInner: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
    },
    cellInnerWrap: {
        height: '100%',
        width: '100%'
    },
    shiftBar: {
        height: '100%'
    },
    innerRowRoot: {
        display: 'flex',
        position: 'relative',
        [`&:hover [control="${tableControlsKeyToHideOnHover}"]`]: {
            display: 'none'
        },
        [`&:hover [control="${tableControlsKeyToShowOnHover}"]`]: {
            visibility: 'visible'
        }
    },
    selectedRowOverlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        border: `solid 2px ${theme.elementBackground}`,
        pointerEvents: 'none'
    },
    isCellInnerSelected: {
        backgroundColor: `${theme.primary} !important`,
        color: `${theme.buttonFontPrimary} !important`,
        '& *': {
            color: `${theme.buttonFontPrimary} !important`
        }
    },
    hierarchyFreeSpace: {}
}))

function TableVirtualizedRow(props) {
    const classes = useStyles()

    const getCellData = (rowData, columnKey) => {
        if (columnKey === undefined) {
            return
        }
        return getObjValueByKey(rowData, columnKey)
    }

    const onClick = event => {
        event.stopPropagation()
        const { onClick, rowData } = props
        if (typeof onClick === 'function') {
            onClick({ rowData, event })
        }
    }

    const renderCell = ({ cellData, column }) => {
        if (column.useEllipsis) {
            return <span className={classes.cellWithEllipsis}>{cellData}</span>
        }
        return cellData
    }

    const {
        style,
        columns,
        columnIndexToWidth,
        rowData,
        customRenderer,
        rowIndex,
        highlightFirstColumnOnHover = false,
        isRowClickable = false,
        rowKey,
        isSelected = false,
        isInsetSelected = false
    } = props

    return (
        <div className={cl(classes.root, classes.rowRootCommon)} style={style} rowkey={rowKey}>
            <div
                className={cl({
                    [classes.innerRowRoot]: true,
                    [classes.clickableInnerRowRoot]: isRowClickable,
                    [classes.highlightFirstColumnOnHover]: highlightFirstColumnOnHover
                })}
                clickablearea="true"
                onClick={onClick}
            >
                {isSelected && <div className={classes.selectedRowOverlay}></div>}
                {columns.map((column, columnIndex) => {
                    const columnKey = column.key
                    const isFirstColumn = !columnIndex
                    const cellData = getCellData(rowData, columnKey)
                    const options = { cellData, columnKey, rowData, column }
                    const customRenderedCell = column.useCustomRenderer ? customRenderer(options) : cellData
                    const renderedCell = renderCell({ cellData: customRenderedCell, column })
                    const columnWidth = columnIndexToWidth[columnIndex]

                    return (
                        <div
                            key={columnKey}
                            className={cl({
                                [classes.cellRoot]: true,
                                [classes.cellRootCommon]: true,
                                [classes.firstCellRootCommon]: isFirstColumn
                            })}
                            style={{ width: columnWidth }}
                            cellcolumnkey={columnKey}
                            columnkey={columnKey}
                        >
                            <div
                                className={cl(rowIndex % 2 ? classes.cellInnerOdd : classes.cellInnerEven, {
                                    [classes.cellInner]: true,
                                    [classes.cellInnerCommon]: true,
                                    [classes.firstCellInner]: isFirstColumn,
                                    [classes.cellAlignCenter]: column.alignCenter,
                                    [classes.isCellInnerSelected]: isInsetSelected
                                })}
                            >
                                {renderedCell}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export { TableVirtualizedRow }
